import { ILogEntry, LogEntryType } from "../../Lib/Log/types";

const formatEntryType = (type: LogEntryType): string => {
    switch (type)
    {
        case LogEntryType.Error:
            return "ERROR";

        case LogEntryType.Warning:
            return "WARN";

        case LogEntryType.Info:
            return "INFO";
    }
};

export const formatMainLogLine = (entry: ILogEntry): string => {
    return [entry.at.toISOString(), formatEntryType(entry.type), entry.message].join('\t');
};

export const formatDataLogLine = (entry: ILogEntry): string => {
    if (!!entry.data)
        return '';

    return `\tDATA - ${JSON.stringify(entry.data)}`;
};

export const getEntriesAsString = (entries: ILogEntry[]): string =>  {

    var lines: string[] = [];

    entries.forEach((entry) => {
        lines.push(formatMainLogLine(entry));

        if (!!entry.data)
            lines.push(formatDataLogLine(entry));
    });

    return lines.join('\n');
};